// extracted by mini-css-extract-plugin
module.exports = {"title":"b7f61a4091cb955017c1636a73efeeb9"};